import { observer } from 'mobx-react';
import { PropertySummary } from './propertySummary';

export const PropertyDetailsLayout = observer(({ store }) => {
  return (
    <PropertySummary store={store} isDownload={false} />
  );
});
